"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authEngineHeader = exports.AuthEngine = void 0;
var AuthEngine;
(function (AuthEngine) {
    AuthEngine["BASIC"] = "basic";
    AuthEngine["AUTH0"] = "auth0";
    AuthEngine["COGNITO"] = "cognito";
    AuthEngine["COGNITO_INTERNAL"] = "cognitoInternal";
    AuthEngine["UNKNOWN"] = "unknown";
})(AuthEngine || (exports.AuthEngine = AuthEngine = {}));
exports.authEngineHeader = "x-auth-engine";
//# sourceMappingURL=AuthEngine.js.map